var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DocumentViewerShell',{staticClass:"document-viewer",attrs:{"document":_vm.item,"toolbar":_vm.toolbar}})
}
var staticRenderFns = []

export { render, staticRenderFns }